import { lastAlarms } from '../constants/last-alarms';

export class LastAlarmsHelper {
    public static getColorByAlarmName(name: string): string | undefined {
        const alarm = lastAlarms.find(alarm => alarm.name === name);

        return alarm?.color;
    }
}
